function debuggrid() {
  let debugGridArState = 0

  document.querySelectorAll('.debuggrid--trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      debugGridArState++
      document.querySelectorAll('.debuggrid').forEach(grid => {
        grid.setAttribute('data-active', debugGridArState % 4)
      })
    })
  })

  window.addEventListener('keydown', (e) => {
    if (e.code === 'KeyQ') {
      debugGridArState++
      document.querySelectorAll('.debuggrid').forEach(grid => {
        grid.setAttribute('data-active', debugGridArState % 4)
      })
    }
  })
}

export default debuggrid
